import React, {useEffect, useState} from 'react';
import {Trans, useTranslation}      from 'react-i18next';
import uuid                         from '../../../utils/uuid';
import {connect}                    from 'react-redux';
import { Grid, Typography}          from '@mui/material';
import Toolbar                      from '../../typography/Toolbar';
import Button                       from '../../inputs/Button';
import {Add}                        from '@mui/icons-material';
import ClassifyTagAutocomplete      from '../../inputs/ClassifyTagAutocomplete';
import {editScheduleTags}           from '../../../../store/actions/planner/ScheduleAction';
import EmptyTags                    from './EmptyTags';
import CreateCategoryDialog         from '../../cms/entry/CreateCategoryDialog';

const ScheduleTags = ({ planner, schedule, tags, fetchTags, scheduleManagingTags, editScheduleTags, isManager, isAdmin, isEvent = false }) => {
	const {t} = useTranslation();
	const [articleTags, setArticleTags] = useState(schedule.Tags ?? []);

	const [originalMapTags, setOriginalMapTags] = useState({});
	const [originalLength, setOriginalLength] = useState();

	const [autocompleteKey, setAutoCompleteKey] = useState(uuid());
	const [createDialogOpened, setCreateDialogOpened] = useState(false);

	const [saveEnabled, setSaveEnabled] = useState(false);


	const refreshAutocompleteList = () => {
		setAutoCompleteKey(uuid());
	};

	useEffect(() => {
		let tags =  schedule.Tags ?? [];

		let original = [...tags];
		original = original.reduce((obj, cur) => ({...obj, [cur.Classify_Tag__]: cur}), {});

		setArticleTags(tags);
		setOriginalLength(Object.keys(original).length);
		setOriginalMapTags(original);
	}, [schedule, setOriginalMapTags, setArticleTags, setOriginalLength]);

	useEffect(() => {
		if (originalLength !== articleTags.length) {
			setSaveEnabled(true);
			return;
		}

		for (let i = 0; i < articleTags.length; i++) {
			if (!(articleTags[i].Classify_Tag__ in originalMapTags)) {
				setSaveEnabled(true);
				return;
			}
		}

		setSaveEnabled(false);


	}, [articleTags, setSaveEnabled, originalMapTags, originalLength]);

	const handleSave = (e) => {
		e.preventDefault();
		let toRemove = {...originalMapTags};
		let toAdd = [];

		for (let i = 0; i < articleTags.length; i++) {
			if (articleTags[i].Classify_Tag__ in toRemove) {
				delete toRemove[articleTags[i].Classify_Tag__];
			} else {
				toAdd.push(articleTags[i].Classify_Tag__);
			}
		}

		toRemove = Object.keys(toRemove);

		e.preventDefault();

		editScheduleTags(schedule.Planner_Schedule__, toAdd, toRemove, isEvent)
	};

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<Toolbar disableGutters title={t('categories')}>
					{isManager &&
					<Button variant="contained" color="primary" startIcon={<Add/>}
					        onClick={() => setCreateDialogOpened(true)}>
						{t('add_btn')}
					</Button>
					}
				</Toolbar>
			</Grid>

			{articleTags.length > 0 && <Grid item xs={12}>
				<Typography variant="body2" color="textSecondary" component="p">
					<Trans i18nKey="schedule_categories_text">
						sample <br/>
						sample
					</Trans>
				</Typography>
			</Grid>}

			<Grid item xs={12}>
				<ClassifyTagAutocomplete
					isAdmin={isAdmin}
					isManager={isManager}
					disabled={!isManager || scheduleManagingTags}
					key={autocompleteKey}
					classifyId={planner ? planner.Classify.Classify__ : ''}
					value={articleTags}
					setValue={setArticleTags}
				/>
			</Grid>

			{articleTags.length < 1 && <Grid item xs={12}><EmptyTags/></Grid>}

			{isManager &&
			<Grid item xs={12}>
				<Grid container justifyContent="flex-end">
					<Button color="primary" variant="contained" loading={scheduleManagingTags} onClick={handleSave}
					        disabled={!saveEnabled || scheduleManagingTags}>
						{t('save_btn')}
					</Button>
				</Grid>
			</Grid>
			}

			{isManager && <CreateCategoryDialog
				open={createDialogOpened}
				setOpen={setCreateDialogOpened}
				classifyId={planner ? planner.Classify.Classify__ : ''}
				onCreated={refreshAutocompleteList}
			/>}

		</Grid>
	);
};

const mapStateToProps = (state) => {
	return {
		scheduleManagingTags: state.schedule.scheduleManagingTags,
		planner: state.schedule.planner,
		isManager: state.access.manager,
		isAdmin: state.access.admin,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		editScheduleTags: (entryId, toAdd, toDelete, isEvent) => dispatch(editScheduleTags(entryId, toAdd, toDelete, isEvent)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleTags);
